"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function isRefinance(loan) {
    return 'propertyValue' in loan;
}
exports.isRefinance = isRefinance;
